export type GreetingStatus = 'nuevo' | 'leido' | 'al_aire' | 'archivado';

export interface AdminGreeting {
  id: number;
  senderName: string;
  senderAvatar: string;
  content: string;
  timestamp: string;
  status: GreetingStatus;
  location: string;
  readAt?: string;
  airedAt?: string;
  archivedAt?: string;
  isHighlighted: boolean;
}

export const adminGreetings: AdminGreeting[] = [
  {
    id: 1,
    senderName: 'Carlos Ramírez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-greet-carlos&orientation=squarish',
    content: 'Un saludo enorme para toda la gente de San José que nos escucha desde temprano. ¡Arriba el barrio El Carmen! Y un abrazo especial para mi esposa Andrea.',
    timestamp: '2026-06-18T14:22:00',
    status: 'nuevo',
    location: 'San José',
    isHighlighted: false,
  },
  {
    id: 2,
    senderName: 'Sofía Hernández',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-greet-sofia&orientation=squarish',
    content: 'Saludos para todo el equipo, son los mejores. Especialmente para Natalia que nos alegra las mañanas y a Diego que siempre me hace reír con sus comentarios.',
    timestamp: '2026-06-18T14:18:00',
    status: 'nuevo',
    location: 'San José',
    isHighlighted: false,
  },
  {
    id: 3,
    senderName: 'Tomás Blanco',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20European%20Latino%20mixed%20man%2C%20creative%20style%2C%20thoughtful%20expression%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-greet-tomas&orientation=squarish',
    content: 'Desde Alajuela mandando un abrazo a todos los escuchas de la noche. Ustedes hacen que manejar de vuelta a casa sea mucho más llevadero. ¡Temazos los de hoy!',
    timestamp: '2026-06-18T14:15:00',
    status: 'nuevo',
    location: 'Alajuela',
    isHighlighted: false,
  },
  {
    id: 4,
    senderName: 'Ana Patricia Vega',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20woman%2C%20elegant%20casual%20style%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20background&width=80&height=80&seq=admin-greet-ana&orientation=squarish',
    content: 'Bendiciones para todo el equipo de Radio Frecuencia. Hoy celebro 10 años de escucharlos todas las mañanas. Son mi compañía fiel camino al trabajo.',
    timestamp: '2026-06-18T14:10:00',
    status: 'nuevo',
    location: 'San José',
    isHighlighted: true,
  },
  {
    id: 5,
    senderName: 'Natalia Campos',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20in%20her%2030s%2C%20warm%20friendly%20smile%2C%20casual%20chic%20style%2C%20soft%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=admin-greet-natalia&orientation=squarish',
    content: 'Buen día a todos! Hoy amanecí con una energía increíble y quería compartirla con todo el equipo. Que tengan un día hermoso lleno de buena música y vibras positivas.',
    timestamp: '2026-06-18T13:55:00',
    status: 'leido',
    location: 'Alajuela',
    readAt: '2026-06-18T14:05:00',
    isHighlighted: false,
  },
  {
    id: 6,
    senderName: 'Camila Soto',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20modern%20trendy%20style%2C%20bright%20genuine%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=admin-greet-camila&orientation=squarish',
    content: 'Buen díaaaas! Saludos al equipo de Tardes de Pop, me acompañan en el gym todas las tardes y hacen mi rutina mucho más divertida. ¡Son lo máximo!',
    timestamp: '2026-06-18T13:40:00',
    status: 'leido',
    location: 'Cartago',
    readAt: '2026-06-18T13:50:00',
    isHighlighted: false,
  },
  {
    id: 7,
    senderName: 'Pedro Gutiérrez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-greet-pedro&orientation=squarish',
    content: 'Saludos desde Alajuela para todos los radioescuchas. Hoy cumplo 25 años de casado y quiero dedicarle un pensamiento a mi esposa Laura. ¡Gracias por acompañarnos siempre!',
    timestamp: '2026-06-18T12:30:00',
    status: 'leido',
    location: 'Alajuela',
    readAt: '2026-06-18T12:45:00',
    isHighlighted: false,
  },
  {
    id: 8,
    senderName: 'María Fernanda López',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20light%20background&width=80&height=80&seq=admin-greet-maria&orientation=squarish',
    content: 'Hola equipo! Quería mandar un saludo muy especial a mi mamá que hoy está de cumpleaños. Ella me enseñó a amar la radio y siempre escuchamos juntas. ¡Los queremos!',
    timestamp: '2026-06-18T11:20:00',
    status: 'al_aire',
    location: 'San José',
    readAt: '2026-06-18T11:25:00',
    airedAt: '2026-06-18T11:35:00',
    isHighlighted: true,
  },
  {
    id: 9,
    senderName: 'Roberto Sánchez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20style%2C%20friendly%20expression%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=admin-greet-roberto&orientation=squarish',
    content: 'Quiero mandar un abrazo enorme a toda la gente de Cartago que nos escucha. Especialmente al equipo de fútbol del barrio que ganó el campeonato. ¡Campeones!',
    timestamp: '2026-06-18T10:45:00',
    status: 'al_aire',
    location: 'Cartago',
    readAt: '2026-06-18T10:50:00',
    airedAt: '2026-06-18T10:52:00',
    isHighlighted: false,
  },
  {
    id: 10,
    senderName: 'Valentina Castro',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background&width=80&height=80&seq=admin-greet-valentina&orientation=squarish',
    content: 'Saluditos desde Heredia para Diego y Natalia. Son los mejores locutores del país. Me acompañan todas las tardes mientras pinto mis cuadros. ¡Son mi inspiración!',
    timestamp: '2026-06-18T10:10:00',
    status: 'al_aire',
    location: 'Heredia',
    readAt: '2026-06-18T10:15:00',
    airedAt: '2026-06-18T10:20:00',
    isHighlighted: false,
  },
  {
    id: 11,
    senderName: 'Francisco Jiménez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%2C%20kind%20weathered%20face%2C%20simple%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-greet-francisco&orientation=squarish',
    content: 'Saludos desde Heredia para todos los radioescuchas de la 98.7 FM. Sintonizándolos desde hace 15 años, el mejor acompañamiento para mis mañanas en el taller. ¡Pura vida!',
    timestamp: '2026-06-18T09:30:00',
    status: 'archivado',
    location: 'Heredia',
    readAt: '2026-06-18T09:35:00',
    airedAt: '2026-06-18T09:40:00',
    archivedAt: '2026-06-18T10:00:00',
    isHighlighted: false,
  },
  {
    id: 12,
    senderName: 'Gabriela Mora',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20professional%20Latina%20woman%2C%20business%20casual%2C%20confident%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-greet-gabriela&orientation=squarish',
    content: 'Solo quería agradecerles por el espacio que dan a artistas nacionales. Descubrí a Los Ecos gracias a ustedes y ahora soy fan número uno. ¡Sigan apoyando el talento tico!',
    timestamp: '2026-06-18T08:45:00',
    status: 'archivado',
    location: 'Limón',
    readAt: '2026-06-18T08:55:00',
    archivedAt: '2026-06-18T09:10:00',
    isHighlighted: false,
  },
  {
    id: 13,
    senderName: 'Javier Núñez',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20trendy%20street%20style%2C%20charismatic%20smile%2C%20urban%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=admin-greet-javier&orientation=squarish',
    content: 'Saludos a toda la banda de San José. Hoy andamos con toda la actitud positiva. Gracias por poner los temazos que alegran el jueves. ¡Pura vida maes!',
    timestamp: '2026-06-18T08:20:00',
    status: 'archivado',
    location: 'San José',
    readAt: '2026-06-18T08:30:00',
    archivedAt: '2026-06-18T09:00:00',
    isHighlighted: false,
  },
  {
    id: 14,
    senderName: 'Lucía Mendoza',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%2C%20natural%20makeup%2C%20casual%20look%2C%20soft%20natural%20light%2C%20clean%20bright%20background&width=80&height=80&seq=admin-greet-lucia&orientation=squarish',
    content: 'Buenas tardes a todos! Quiero mandar un saludo muy cariñoso a mi abuelita que está en el hospital. Ella es fan #1 de Radio Frecuencia. Abuelita, ¡te amamos y pronto en casa!',
    timestamp: '2026-06-17T19:30:00',
    status: 'archivado',
    location: 'Heredia',
    readAt: '2026-06-17T19:35:00',
    airedAt: '2026-06-17T19:42:00',
    archivedAt: '2026-06-17T20:00:00',
    isHighlighted: true,
  },
  {
    id: 15,
    senderName: 'Diego Vargas',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=admin-greet-diego&orientation=squarish',
    content: 'Saludos a la mejor radio del país. Los escucho desde que abrí mi cafetería en el centro y todos mis clientes ya son fans. ¡Sigan poniendo esa buena música!',
    timestamp: '2026-06-17T17:15:00',
    status: 'archivado',
    location: 'Alajuela',
    readAt: '2026-06-17T17:20:00',
    archivedAt: '2026-06-17T18:00:00',
    isHighlighted: false,
  },
  {
    id: 16,
    senderName: 'Daniela Quirós',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%2C%20sporty%20casual%20look%2C%20energetic%20smile%2C%20bright%20natural%20light%2C%20clean%20background&width=80&height=80&seq=admin-greet-daniela&orientation=squarish',
    content: 'Hola hola! Saludos a todo el team de la mañana. Hoy es mi primer día de vacaciones y lo primero que hice fue sintonizarlos. No hay mejor forma de empezar el día.',
    timestamp: '2026-06-18T14:05:00',
    status: 'nuevo',
    location: 'San José',
    isHighlighted: false,
  },
  {
    id: 17,
    senderName: 'Eduardo Paredes',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20professional%20style%2C%20friendly%20but%20serious%20expression%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=admin-greet-eduardo&orientation=squarish',
    content: 'Un abrazo a todos los oyentes desde el Mercado Central. Aquí en la sodita los tenemos puestos todo el día. La clientela ya pide que no cambiemos de emisora. ¡Son parte de la familia!',
    timestamp: '2026-06-18T08:55:00',
    status: 'leido',
    location: 'San José',
    readAt: '2026-06-18T09:05:00',
    isHighlighted: false,
  },
  {
    id: 18,
    senderName: 'Andrea Torres',
    senderAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20bright%20smile%2C%20everyday%20casual%20look%2C%20soft%20daylight%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20light%20background&width=80&height=80&seq=admin-greet-andrea&orientation=squarish',
    content: 'Qué bonito programa el de hoy. Me encantó la entrevista con la banda nueva. Saludos para Carlos, mi esposo, que está en el taller escuchándonos. ¡Te amo mi vida!',
    timestamp: '2026-06-18T09:40:00',
    status: 'al_aire',
    location: 'Cartago',
    readAt: '2026-06-18T09:45:00',
    airedAt: '2026-06-18T09:48:00',
    isHighlighted: true,
  },
];

export const statusLabels: Record<GreetingStatus, string> = {
  nuevo: 'Nuevo',
  leido: 'Leído',
  al_aire: 'Al Aire',
  archivado: 'Archivado',
};

export const statusColors: Record<GreetingStatus, { dot: string; bg: string; text: string }> = {
  nuevo: { dot: 'bg-primary-500', bg: 'bg-primary-50 border-primary-200', text: 'text-primary-700' },
  leido: { dot: 'bg-foreground-400', bg: 'bg-foreground-50 border-foreground-200', text: 'text-foreground-600' },
  al_aire: { dot: 'bg-rose-500 animate-pulse', bg: 'bg-rose-50 border-rose-200', text: 'text-rose-700' },
  archivado: { dot: 'bg-amber-500', bg: 'bg-amber-50/60 border-amber-200', text: 'text-amber-700' },
};